<ng-container *ngIf="noAvatar; else avatar">
	<div class="initial d-flex justify-content-center align-items-center" *ngIf="user?.email">
		{{ user?.email ? (email | firstLetter: true) : '' }}
	</div>
	<eqa-svg *ngIf="!user?.email" src="eqaAvatar"></eqa-svg>
</ng-container>
<ng-template #avatar>
	<div [style.background-image]="'url(' + user.avatar +')'" class="eqa-ava"></div>
</ng-template>
